import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCalendarAlt,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCheck,
  faCircle,
  faExclamationTriangle,
  faMinus,
  faPen,
  faPlus,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faTimes,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BootstrapVue from 'bootstrap-vue';
import Croppa from 'vue-croppa';
import configureValidation from './configureValidation';
import App from './App.vue';
import router from './router';
import store from './store/store';
import configureFilters from '@/configureFilters';
import '../sass/base.scss';
import '../sass/contacts.scss';

library.add(
  faCalendarAlt,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCheck,
  faCircle,
  faMinus,
  faPen,
  faPlus,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faTimes,
  faTrashAlt,
  faExclamationTriangle,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
configureValidation();

Vue.use(VeeValidate, {
  classes: true,
  // Use bootstrap form validation classes
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid',
  },
  // Disable inferred rules (type="number" attribute will not trigger decimal validation)
  useConstraintAttrs: false,
});

Vue.use(Croppa);

configureFilters();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
